function initValues() {
  if($('.grid-proposal').is(':visible')){
    if (!$('.grid-proposal').hasClass("slick-initialized")) {
      $('.grid-proposal').slick({
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        accessibility: true,
        draggable: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {

              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '150px'
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '100px'
            }
          },
          {
            breakpoint: 645,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '80px'
            }
          }
        ]
      });
    }
  }
}

initValues();

function initValuesCollection() {
  if($('.grid-collection-proposal').is(':visible')){
    if (!$('.grid-collection-proposal').hasClass("slick-initialized")) {
      $('.grid-collection-proposal').slick({
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        accessibility: true,
        draggable: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              draggable: true,
              variableWidth: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              draggable: true,
              variableWidth: true,
              arrows: true
            }
          },
          {
            breakpoint: 645,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              draggable: true,
              variableWidth: true,
              arrows: true
            }
          }
        ]
      });
    }
  }
}
initValuesCollection();
